import React from 'react';
import RunningGuy from './RunningGuy';

class GoogleFitRequired extends React.Component {
    constructor(props){
        super(props);
        this.state = {};
    }

    render(){
        return (
            <div className={'container'}>
                <div style={{display:'flex', flexDirection:'column', justifyContent:'center', textAlign:'center'}}>
                    <div style={{maxWidth:'90%', margin:'0 5%'}}>
                            <br /><RunningGuy />
                    </div>
                    <div style={{padding:'0 25px 0 25px'}}  className={'grey-font'}>
                    <div style={{paddingTop:20}}>
                        <span className={'activity-tracker-permissions-header'}>Track your steps and earn digital badges!</span>
                    </div>
                    <div style={{textAlign:'left',paddingTop:10, paddingBottom:10}}>
                        <div style={{paddingTop:10, paddingBottom:10}}>
                            <span className={'activity-tracker-permissions-description google-fit-warning'}>Google Fit App Required!</span>
                        </div>
                        <div style={{paddingTop:10, paddingBottom:10}}>
                            <span className={'activity-tracker-permissions-description'}>Tap the button below to open the play store to install the Google Fit App.</span>
                        </div>
                        <div style={{paddingTop:10, paddingBottom:10}}>
                            <span className={'activity-tracker-permissions-description'}>To get real time step data make sure you sign into your Google account in the Google Fit app once installed.</span>
                        </div>
                    </div>
                        <br />
                        {this.props.button}
                    </div>

                </div>
            </div>
        )
    }
}

export default GoogleFitRequired;


// WEBPACK FOOTER //
// ./src/Components/ActivityTracker/GoogleFitRequired.js